<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                        <div>
                            <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                        </div>
                        <div>Cette interface vous permet d'encaisser les commandes en attente. Il y a actuellement <b>{{
                            pendings_commandes.length }}</b> commandes à encaisser.</div>
                        <div class="d-flex justify-space-between align-center ga-2">
                            <SportipsButton icon="mdi-currency-eur" chevron @click="launch_charge_commandes()">Lancer
                                l'encaissement automatique</SportipsButton>
                            <v-text-field v-model="limit" type="number" min="1" max="1000"
                                label="Nombre de commandes à encaisser" density="compact" hide-details></v-text-field>
                            <div>
                                <div>Succès: {{ stats.success }}</div>
                                <div>Erreur: {{ stats.error }}</div>
                                <div>Total: {{ stats.total }}</div>
                            </div>
                        </div>

                        <div v-for="commande in pendings_commandes" :key="commande.id"
                            class="spo-card pa-2 rounded bordered">
                            <div class="d-flex justify-space-between">
                                <div>
                                    <div class="font-weight-bold">Commande n°{{ commande.uuid }}</div>
                                    <div class="text-subtitle-1">{{ commande.prix_total }}€ | Validée le {{
                                        $moment(commande.created_at).format("DD/MM/YYYY à HH:mm") }}</div>
                                </div>
                                <div>
                                    <v-chip :color="get_color_status(commande.status)" variant="elevated" elevation="0">
                                        {{ commande.status }}
                                    </v-chip>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import AdminService from "@/services/admin.service";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    name: 'ChargePendingsCommandes',
    data() {
        return {
            pendings_commandes: [],
            limit: 100,
            stats: {
                success: 0,
                error: 0,
                total: 0,
            }
        }
    },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        get_color_status(status) {
            if (status == 'PAID') return 'green-darken-4';
            if (status == 'PENDING') return 'primary-dark';
            return 'red-darken-4';
        },
        async fetch_pendings_commandes() {
            let request = await AdminService.getPendingsCommandes(this.mainStore.module.id);
            console.log(request);
            if (request) {
                this.pendings_commandes = request;
            }
        },
        async launch_charge_commandes() {
            this.stats.success = 0;
            this.stats.error = 0;
            this.stats.total = 0;
            for (let i = 0; i < this.limit; i++) {
                if (this.pendings_commandes[i].status == 'PAID') continue;
                let response = await AdminService.chargeCommande(this.pendings_commandes[i].id_commande);
                if (response) {
                    this.pendings_commandes[i].status = response;
                    if (response == "PAID") {
                        this.stats.success++;
                    }
                    else {
                        this.stats.error++;
                    }
                    this.stats.total++;
                }
            }

        }
    },
    async mounted() {

        if (!this.mainStore.authAdmin.hasSuperAdminRights) {
            this.$router.push({ name: 'Administration' });
        }
        await this.fetch_pendings_commandes();

    }
}
</script>

<style lang="scss" scoped></style>